import { MEDIA_URL } from '@/constants/env';

export const seo = {
  description:
    'Your EPC partner in industrial solutions. This group of companies has over 30 years of experience in providing solutions for the energy, mining, water, oil & gas and (petro) chemical industries with their Engineering, Manpower, Construction & Facility Management subsidiaries.',
  image: MEDIA_URL.concat('/og-image.png'),
  keywords: 'cead, engineering, manpower, construction, suriname',
};
